import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var nodesSeen = 0;
export var BelNode = /*#__PURE__*/function () {
  /** List of other BelNode derivatives. Each children should be of a subclass that implements its own 'serialize' function. */
  function BelNode(agentIdentifier) {
    _classCallCheck(this, BelNode);

    _defineProperty(this, "belType", void 0);

    _defineProperty(this, "children", []);

    _defineProperty(this, "start", void 0);

    _defineProperty(this, "end", void 0);

    _defineProperty(this, "callbackEnd", 0);

    _defineProperty(this, "callbackDuration", 0);

    _defineProperty(this, "nodeId", ++nodesSeen);

    if (!agentIdentifier) throw new Error('Interaction is missing core attributes');
    this.agentIdentifier = agentIdentifier;
  }

  _createClass(BelNode, [{
    key: "addChild",
    value: function addChild(child) {
      this.children.push(child);
    }
    /** Virtual fn for stringifying an instance. */

  }, {
    key: "serialize",
    value: function serialize() {}
  }]);

  return BelNode;
}();